(() => {
  const normalise = (s) =>
    (s || "")
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".glossary[data-section-id]").forEach((root) => {
      const searchInput = root.querySelector(".glossary__search");
      const clearBtn = root.querySelector(".glossary__clear");
      const countEl = root.querySelector(".glossary__count");
      const noResultsEl = root.querySelector("[data-glossary-noresults]");

      if (!searchInput || !clearBtn || !countEl || !noResultsEl) return;

      // We rely on the Liquid output: <dt data-glossary-term data-search="..."> ... </dt><dd>...</dd>
      const dts = Array.from(root.querySelectorAll("dt[data-glossary-term]"));
      if (!dts.length) return;

      const detailsEls = Array.from(root.querySelectorAll("details.accordion-details"));

      const showDt = (dt, show) => {
        const dd = dt.nextElementSibling; // <dd> should immediately follow <dt>
        dt.hidden = !show;
        if (dd && dd.tagName === "DD") dd.hidden = !show;
      };

      const apply = () => {
        const qRaw = searchInput.value || "";
        const q = normalise(qRaw);

        clearBtn.hidden = !q;

        let matches = 0;

        // 1) Filter individual terms
        dts.forEach((dt) => {
          const haystack = normalise(dt.getAttribute("data-search") || "");
          const ok = !q || haystack.includes(q);
          showDt(dt, ok);
          if (ok) matches++;
        });

        // 2) Show/hide and open accordion panels based on visible terms INSIDE them
        detailsEls.forEach((details) => {
          const itemWrap = details.closest(".accordion-item");
        
          const visibleCount = details.querySelectorAll(
            "dt[data-glossary-term]:not([hidden])"
          ).length;
        
          const hasVisible = visibleCount > 0;
        
          // When searching, hide empty panels. When not searching, show all.
          if (itemWrap) itemWrap.hidden = q ? !hasVisible : false;
        
          if (q) {
            // Searching: open all panels that contain matches
            details.open = hasVisible;
          } else {
            // Cleared: close all panels
            details.open = false;
          }
        });

        noResultsEl.hidden = matches > 0;

        countEl.textContent = q
          ? `${matches} result${matches === 1 ? "" : "s"} for “${qRaw}”.`
          : `${dts.length} term${dts.length === 1 ? "" : "s"}.`;
      };

      let t;
      searchInput.addEventListener("input", () => {
        clearTimeout(t);
        t = setTimeout(apply, 80);
      });

      clearBtn.addEventListener("click", () => {
        searchInput.value = "";
        searchInput.focus();
        apply();
      });

      apply();
    });
  });
})();